import { useFormContext } from 'react-hook-form';

import type { FormTextareaProps } from '../types';
import type { FieldValues } from 'react-hook-form';

import { Textarea } from '@/components/Textarea';
import { Field, FieldDescription, FieldError } from '@/components/ui/field';
import { FormField } from '@/components/ui/form';

export const FormTextarea = <TFieldValues extends FieldValues = FieldValues>(
  props: FormTextareaProps<TFieldValues>,
) => {
  const { name, label, description, isRequired, rows, textareaProps, control } =
    props;
  const formContext = useFormContext<TFieldValues>();
  const formControl = control || formContext.control;

  const fieldId = `form-field-${String(name)}`;

  return (
    <FormField
      control={formControl}
      name={name}
      render={({ field, fieldState }) => {
        const fieldLabel = (
          <>
            {label}
            {isRequired && (
              <span
                className={
                  fieldState.invalid
                    ? 'text-destructive'
                    : 'text-muted-foreground'
                }
              >
                *
              </span>
            )}
          </>
        );

        return (
          <Field data-invalid={fieldState.invalid}>
            <Textarea
              {...field}
              id={fieldId}
              label={fieldLabel}
              rows={rows}
              aria-invalid={fieldState.invalid}
              {...textareaProps}
            />
            {fieldState.invalid && <FieldError errors={[fieldState.error]} />}
            {description && <FieldDescription>{description}</FieldDescription>}
          </Field>
        );
      }}
    />
  );
};
